import IMarkerCoordsParams from '../../types/IMarkerCoordsParams';

const centerMapByMarkerCoords = (params: IMarkerCoordsParams): void => {
  const { position, mapRef } = params;

  mapRef.value.panTo(position);
};
export default centerMapByMarkerCoords;
